module.exports = __webpack_public_path__ + "static/media/menu-people.915796fc.svg";